import { useAppStore } from '../stores';

export const useLoading = () => {
  const loading = useAppStore((state) => state.ui.loading);
  const setLoading = useAppStore((state) => state.setLoading);

  return {
    loading,
    setLoading,
  };
};
